import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail__limit-fill" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["detail__limit-segment", 'detail__limit-segment--' + _ctx.barStatus]),
      style: _normalizeStyle({width: _ctx.confirmedWidth})
    }, null, 6),
    _createElementVNode("div", {
      class: "detail__limit-segment detail__limit-segment--frozen",
      style: _normalizeStyle({width: _ctx.frozenWidth})
    }, null, 4)
  ]))
}